export const setapikey = {
    'en': 'Set API key [KEY]',
    'zh-tw': 'API金鑰[KEY]',
};

export const settitle = {
    'en': 'Set title text [TITLE]',
    'zh-tw': '設定抬頭[TITLE]',
};

export const TokenNull ={
    'en': 'Token or Message is null',
    'zh-tw': '權杖或傳送訊息錯誤',
};

export const sendmessage ={
    'en': 'Set content text [CONTENT]',
    'zh-tw': '設定送出內容[CONTENT]',
};
export const seturl ={
    'en': 'Set url [URL] ',
    'zh-tw': '設定超連結[URL]',
};




